import {
  Edit,
  CardActions,
  ListButton,
  RefreshButton,
  DeleteButton,
  translate
} from "react-admin";
import React from "react";

import AnnounceForm from "./AnnounceForm";

const AnnounceTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("announce.announce")}`} {record ? `"${record.title}"` : ""}
    </span>
  );
};

const Title = translate(AnnounceTitle);

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    <DeleteButton basePath={basePath} record={data} resource={resource} />
    <RefreshButton />
  </CardActions>
);

export const AnnounceEdit = props => (
  <Edit actions={<Actions />} title={<Title />} {...props}>
    <AnnounceForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/announce/AnnounceEdit.js